"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEnhancer = void 0;
var mediaquery_1 = __importDefault(require("mediaquery"));
var actions_1 = require("./actions");
var utils_1 = require("./utils");
function createEnhancer(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.calculateInitialState, calculateInitialState = _c === void 0 ? true : _c;
    // return the store enhancer (an enhanced version of `createStore`)
    return function (createStore) { return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // create the store
        var store = createStore.apply(void 0, args);
        // if there is a `window`
        if (typeof window !== 'undefined' &&
            typeof window.matchMedia !== 'undefined') {
            // add the handlers that only fire when the responsive state changes
            addHandlers({ store: store, window: window, calculateInitialState: calculateInitialState });
        }
        // return the store so that the call is transparent
        return store;
    }; };
}
exports.createEnhancer = createEnhancer;
/**
 * Creates a store enhancer based off an (optional) throttle time.
 * @arg {object} [options={calculateInitialState}] - Options object.
 * @arg {boolean} [options.calculateInitialState=true] - True if the responsive
 * state must be calculated initially, false otherwise.
 * @returns {function} - The store enhancer (which adds event listeners to
 * dispatch actions on window resize).
 */
function addHandlers(_a) {
    var store = _a.store, window = _a.window, calculateInitialState = _a.calculateInitialState;
    // the function to call when calculating the new responsive state
    var refreshResponsiveState = function () {
        return store.dispatch(actions_1.calculateResponsiveState(window));
    };
    // get the object of media queries corresponding to the breakpoints in the store
    var mediaQueries = mediaquery_1.default.asObject(utils_1.getBreakpoints(store));
    // for every breakpoint range
    Object.keys(mediaQueries).forEach(function (breakpoint) {
        // create a media query list for the breakpoint
        var mediaQueryList = window.matchMedia(mediaQueries[breakpoint]);
        /* eslint-disable no-loop-func */
        // whenever any of the media query lists status changes
        mediaQueryList.addListener(function (query) {
            // if a new query was matched
            if (query.matches) {
                // recaulate the state
                refreshResponsiveState();
            }
        });
    });
    // make sure we update the responsive state when the browser changes orientation
    window.addEventListener('orientationchange', refreshResponsiveState);
    // if we are supposed to calculate the initial state
    if (calculateInitialState) {
        // then do so
        refreshResponsiveState();
    }
}
var responsiveStoreEnhancer = createEnhancer();
exports.default = responsiveStoreEnhancer;
//# sourceMappingURL=enhancer.js.map